import { render, staticRenderFns } from "./checkboxOptionSet.vue?vue&type=template&id=4019464f&scoped=true&"
import script from "./checkboxOptionSet.vue?vue&type=script&lang=js&"
export * from "./checkboxOptionSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4019464f",
  null
  
)

export default component.exports